"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _Personnummer_instances, _Personnummer_century, _Personnummer_fullYear, _Personnummer_year, _Personnummer_month, _Personnummer_day, _Personnummer_num, _Personnummer_check, _Personnummer_parse, _Personnummer_valid;
Object.defineProperty(exports, "__esModule", { value: true });
const errors_1 = __importDefault(require("./errors"));
const utils_1 = require("./utils");
const country = 'no';
const weightsCheck1 = [3, 7, 6, 1, 8, 9, 4, 5, 2];
const weightsCheck2 = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
class Personnummer {
    /**
     * Get century.
     */
    get century() {
        return __classPrivateFieldGet(this, _Personnummer_century, "f");
    }
    /**
     * Get age.
     */
    get fullYear() {
        return __classPrivateFieldGet(this, _Personnummer_fullYear, "f");
    }
    /**
     * Get year.
     */
    get year() {
        return __classPrivateFieldGet(this, _Personnummer_year, "f");
    }
    /**
     * Get month.
     */
    get month() {
        return __classPrivateFieldGet(this, _Personnummer_month, "f");
    }
    /**
     * Get day.
     */
    get day() {
        return __classPrivateFieldGet(this, _Personnummer_day, "f");
    }
    /**
     * Get num.
     */
    get num() {
        return __classPrivateFieldGet(this, _Personnummer_num, "f");
    }
    /**
     * Get check.
     */
    get check() {
        return __classPrivateFieldGet(this, _Personnummer_check, "f");
    }
    /**
     * Personnummer constructor.
     */
    constructor(ssn, options = {}) {
        _Personnummer_instances.add(this);
        /**
         * Personnummer century.
         */
        _Personnummer_century.set(this, void 0);
        /**
         * Personnummer full year.
         */
        _Personnummer_fullYear.set(this, void 0);
        /**
         * Personnummer year.
         */
        _Personnummer_year.set(this, void 0);
        /**
         * Personnummer month.
         */
        _Personnummer_month.set(this, void 0);
        /**
         * Personnummer day.
         */
        _Personnummer_day.set(this, void 0);
        /**
         * Get sep.
         */
        this.sep = '';
        /**
         * Personnumer first three of the last four numbers.
         */
        _Personnummer_num.set(this, void 0);
        /**
         * The last number of the personnummer.
         */
        _Personnummer_check.set(this, void 0);
        __classPrivateFieldGet(this, _Personnummer_instances, "m", _Personnummer_parse).call(this, ssn, options);
    }
    /**
     * Parse personnummer.
     */
    static parse(ssn, options = {}) {
        return new Personnummer(ssn, options);
    }
    /**
     * Validate a Norwegian personal identity number.
     */
    static valid(ssn, options) {
        try {
            Personnummer.parse(ssn, options);
            return true;
        }
        catch (_) {
            return false;
        }
    }
    /**
     * Format a Norwegian personal identity number.
     *
     * If the input number could not be parsed a empty string will be returned.
     */
    format() {
        return `${this.day}${this.month}${this.year}${this.num}${this.check}`;
    }
    /**
     * Get age from a Norwegian personal identity number.
     */
    getAge() {
        let ageDay = +this.day;
        if (this.isCoordinationNumber()) {
            ageDay -= 40;
        }
        const ageDate = `${this.fullYear}-${this.month}-${ageDay}`;
        return (0, utils_1.diffInYears)(new Date(), new Date(ageDate));
    }
    /**
     * Check if a Norwegian personal identity number is a coordination number or not.
     */
    isCoordinationNumber() {
        return (0, utils_1.testDate)(+this.fullYear, +this.month, +this.day - 40);
    }
    /**
     * Check if a Norwegian personal identity number is for a female.
     */
    isFemale() {
        return !this.isMale();
    }
    /**
     * Check if a Norwegian personal identity number is for a male.
     */
    isMale() {
        const sexDigit = this.num.substr(-1);
        return parseInt(sexDigit, 10) % 2 === 1; // Odd => male
    }
}
_Personnummer_century = new WeakMap(), _Personnummer_fullYear = new WeakMap(), _Personnummer_year = new WeakMap(), _Personnummer_month = new WeakMap(), _Personnummer_day = new WeakMap(), _Personnummer_num = new WeakMap(), _Personnummer_check = new WeakMap(), _Personnummer_instances = new WeakSet(), _Personnummer_parse = function _Personnummer_parse(ssn, options = {}) {
    if (typeof ssn !== 'string') {
        throw new errors_1.default(country);
    }
    const reg = /^(\d{2})(\d{2})(\d{2})(\d{3})(\d{2})$/;
    const match = reg.exec(ssn);
    if (!match) {
        throw new errors_1.default(country);
    }
    const day = match[1];
    const month = match[2];
    const year = match[3];
    const num = match[4];
    const check = match[5];
    const numParsed = parseInt(num, 10);
    const yearParsed = parseInt(year, 10);
    let century = '19'; // num 0-499 => 1900-1999
    if (numParsed > 499) {
        if (numParsed < 750 && yearParsed >= 54) { // 500-749 => 1854-1899
            century = '18';
        }
        else if (yearParsed < 40) { // 500-999 => 2000-2039
            century = '20';
        }
        else if (numParsed >= 900 && yearParsed >= 40) { // 900-999 => 1940-19999
            century = '19';
        }
    }
    __classPrivateFieldSet(this, _Personnummer_century, century, "f");
    __classPrivateFieldSet(this, _Personnummer_year, year, "f");
    __classPrivateFieldSet(this, _Personnummer_fullYear, `${century}${year}`, "f");
    __classPrivateFieldSet(this, _Personnummer_month, month, "f");
    __classPrivateFieldSet(this, _Personnummer_day, day, "f");
    __classPrivateFieldSet(this, _Personnummer_num, num, "f");
    __classPrivateFieldSet(this, _Personnummer_check, check, "f");
    if (!__classPrivateFieldGet(this, _Personnummer_instances, "m", _Personnummer_valid).call(this)) {
        throw new errors_1.default(country);
    }
}, _Personnummer_valid = function _Personnummer_valid() {
    const c1 = (0, utils_1.weightedMod11)(`${this.day}${this.month}${this.year}${this.num}`, weightsCheck1);
    const c2 = (0, utils_1.weightedMod11)(`${this.day}${this.month}${this.year}${this.num}${this.check.substring(0, 1)}`, weightsCheck2);
    const valid = `${c1}${c2}` === this.check;
    if (valid &&
        (0, utils_1.testDate)(+this.fullYear, +this.month, +this.day))
        return true;
    return valid && (0, utils_1.testDate)(+this.fullYear, +this.month, +this.day - 40);
};
module.exports = Personnummer;
exports.default = Personnummer;
//# sourceMappingURL=no.js.map